import { coreInstance, backendVersion } from "@/axios-path.js";

export default {
  namespaced: true,
  state: {
    provice: [],
    vehicle_type: [],
    thai_bank: []
  },
  mutations: {
    getProvice(state, data) {
      state.provice = data;
    },
    getVehicleType(state, data) {
      state.vehicle_type = data;
    },
    getThaiBank(state, data) {
      state.thai_bank = data;
    }
  },
  actions: {
    async getProvice({ commit, state, dispatch }) {
      let url = backendVersion.version + "/Province/";
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("getProvice", res);
      }
    },
    async getVehicleType({ commit, state, dispatch }) {
      let url = backendVersion.version + "/Office/Vehicle";
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("getVehicleType", res);
      }
    },
    async getThaiBank({ commit, state, dispatch }) {
      let url = backendVersion.version + "/Office/Setbank/";
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("getThaiBank", res);
      }
    }
  }
};
